import { Dispatch } from 'redux';
import { newsActions } from 'src/slices/news-slice';
import { ApiNews } from './../http/api-news';

const {
  setNewsListFailure,
  setNewsListRequest,
  setNewsListSuccess,
  setNewsPostFailure,
  setNewsPostRequest,
  setNewsPostSuccess,
} = newsActions;

export const getNews = (params?: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setNewsListRequest());
  try {
    const data = await ApiNews.fetchAll(params);
    dispatch(setNewsListSuccess(data));
  } catch (error) {
    dispatch(setNewsListFailure(error));
  }
};

export const getPost = (params: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setNewsPostRequest());
  try {
    const { id, language, ...rest } = params;
    const i18nPosts = await ApiNews.getLanguageLinks(id);
    const translatedId = i18nPosts.links[language];
    const data = await ApiNews.fetchOne({ id: translatedId, ...rest });
    dispatch(setNewsPostSuccess(data));
  } catch (error) {
    dispatch(setNewsPostFailure(error));
  }
};

export const getLanguageLinks = (id: string | number) => async (dispatch: Dispatch) => {
  try {
    const data = await ApiNews.getLanguageLinks(id);
    return data;
  } catch (error) {
    return error;
  }
};
